import {
  REQUIRED,
  VALID_NUMBER,
  VALID_EMAIL,
  VALID_PHONE,
} from './validations';

export const validationByFieldType = {
  Number: VALID_NUMBER,
  Email: VALID_EMAIL,
  Phone: VALID_PHONE,
};

export const getValidations = (isRequired, validationName) => {
  const validations = [];
  if (isRequired) {
    validations.push(REQUIRED);
  }
  if (validationName) {
    validations.push(validationByFieldType[validationName]);
  }
  return validations;
};



// WEBPACK FOOTER //
// ./src/helpers/validationByFieldType.js